
































































































import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Utils
 */
import * as imageLinks from "@/config/image-links";
import itemClasses from "@/config/wow/item-classes";
import itemSlots from "@/config/wow/item-slots";
import difficulties from "@/config/wow/difficulties";

/**
 * Components
 */

/**
 * Types
 */
interface LootWish {
	id: number;
	lootID: number;
	value: number;
	difficulty: number | null;
	note: string;
}

interface Loot {
	id: number;
	name: string;
	itemId: number;
	icon: string;
	quality: number;
	slot: number;
	class: number;
	subClass: number;
}

/**
 * Mixins
 */

/**
 * Character wishes editor page.
 */
@Component
export default class LootCard extends Vue {
	/// Injections
	imageLinks = imageLinks;
	difficulties = difficulties;
	itemClasses = itemClasses;
	itemSlots = itemSlots;

	get wishValuesChoices() {
		return [
			{val: 0},
			{val: 10},
			{val: 15},
			{val: 20},
			{val: 30}
		];
	}

	/// Attributes
	@Prop() loot!: Loot;
	@Prop() lootWish!: LootWish | null;
	@Prop() handleRateLoot!: (lootID: number, value: number) => void;
	@Prop() handleEditDifficultyLoot!: (lootID: number, difficulty: number | null) => void;
	@Prop() handleEditNoteLoot!: (lootID: number, note: string) => void;

	/// Methods
	async created() {
	}

	get hasLootWish() {
		return this.lootWish && this.lootWish.value > 0;
	}
}
